<template>
  <div class="space-y-16 container mx-auto">
    <div
      class="
        flex
        justify-between
        w-full
        shadow
        sm:rounded-md sm:overflow-hidden
        px-4
        py-5
        bg-white
        space-y-6
        sm:p-6
      "
    >
      <div class="space-y-1">
        <h1 class="text-2xl text-gray-900 leading-7 font-bold">Your Case</h1>
        <h5 v-if="cases.sell_case.amount" class="text-green-500 font-semibold leading-5 text-sm">
          Sale of {{cases.sell_case.address.street_address}}
        </h5>
        <h5 v-if="cases.purchase_case.amount" class="text-red-500 font-semibold leading-5 text-sm">
          Purchase of {{cases.purchase_case.address.street_address}}
        </h5>
      </div>
      <router-link
        to="/onboarding/step/1"
        class="
          inline-flex
          items-center
          px-4
          py-2
          border border-transparent
          text-sm
          font-medium
          rounded-md
          shadow-sm
          text-white
          bg-light-blue-700
          hover:bg-light-blue-800
          focus:outline-none
          focus:ring-2
          focus:ring-offset-2
          focus:ring-light-blue-500
        "
      >
        Edit information
      </router-link>
    </div>
    <div class="px-4 sm:px-8 xl:pr-16 grid grid-cols-2">
      <div>
        <h1
          class="
            text-4xl
            tracking-tight
            font-extrabold
            text-gray-800
            sm:text-5xl
            md:text-6xl
            lg:text-5xl
            xl:text-6xl
          "
        >
          <span class="block xl:inline"
            >{{cases.personal.first_name}}, here is your calculated quote:</span
          >
        </h1>
      </div>
      <img src="@/assets/img/onboarding-qutoe.svg" />
    </div>
    <div class="flex flex-col">
      <div class="-my-2 sm:-mx-6 lg:-mx-8">
        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <div
            class="
              shadow
              overflow-hidden
              border-b border-gray-200
              sm:rounded-lg
            "
          >
            <table class="min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-50">
                <tr>
                  <th
                    scope="col"
                    class="
                      px-6
                      py-3
                      text-left text-xs
                      font-medium
                      text-gray-500
                      uppercase
                      tracking-wider
                    "
                  >
                    SERVICE
                  </th>
                  <th
                    scope="col"
                    class="
                      px-6
                      py-3
                      text-left text-xs
                      font-medium
                      text-gray-500
                      uppercase
                      tracking-wider
                    "
                  >
                    DESCRIPTION
                  </th>
                  <th
                    scope="col"
                    class="
                      px-6
                      py-3
                      text-left text-xs
                      font-medium
                      text-gray-500
                      uppercase
                      tracking-wider
                    "
                  >
                    AMOUNT
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(service, k) in services"
                  :key="service.email"
                  :class="k % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                >
                  <td
                    :class="[
                      {
                        'text-base font-bold': service.name == 'TOTAL',
                      },
                      'px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900',
                    ]"
                  >
                    {{ service.name }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {{ service.description }}
                  </td>
                  <td
                    :class="[
                      {
                        'text-base font-bold': service.name == 'TOTAL',
                      },
                      'px-6 py-4 whitespace-nowrap text-sm text-gray-500',
                    ]"
                  >
                    {{ service.amount }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="w-full ml-auto max-w-3xl space-y-8 pb-8">
      <div
        class="
          flex
          justify-between
          w-full
          flex-wrap
          shadow
          sm:rounded-md sm:overflow-hidden
          px-4
          py-5
          bg-white
          space-y-6
          sm:p-6
        "
      >
        <div class="space-y-1 max-w-xl">
          <h1 class="text-2xl text-gray-900 leading-7 font-bold">
            Pay {{cases.property === 'both' ? '£200.00' :'£100.00'}} deposit to start your {{cases.property === 'both' ? 'selling & purchasing ' : cases.property ==='sale' ?'selling' :'purchasing' }} process
          </h1>
          <h5 class="text-gray-500 leading-5 text-sm">
           Once you have made payment you will get a confirmation email with Instructions to the 
           <span class="font-semibold">Ashley James Solicitors Dashboard</span>
            where you can proceed with your case further.
          </h5>
        </div>
        <button
          @click="redirectToCheckout"
          type="button"
          class="
            inline-flex
            items-center
            h-9
            px-4
            py-2
            border border-transparent
            text-sm
            font-medium
            rounded-md
            shadow-sm
            text-white
            bg-light-blue-700
            hover:bg-light-blue-800
            focus:outline-none
            focus:ring-2
            focus:ring-offset-2
            focus:ring-light-blue-500
          "
        >
          Pay now
        </button>
      </div>
      <div
        class="
          text-sm
          leading-5
          grid
          lg:grid-cols-3
          gap-y-4
          text-gray-900
          px-4
          py-5
          lg:px-0 lg:py-0
        "
      >
        <div class="border-gray-400 lg:border-r xl:border-r mr-9">
          <p class="w-44">
            Quote reference number:
            <span class="font-semibold">AJQTE-0194/150421/005</span><br />
          {{DateTime.now().toLocaleString(DateTime.DATETIME_MED)}}
          </p>
        </div>
        <p class="w-full col-span-2">
         See our <a rel="noopener" target="_blank" class="font-medium text-blue-600 hover:text-blue-500" href="https://www.ajsolicitors.com/menu-of-additional-legal-services.pdf">Schedule of Additional Charges</a> for any additional fees that may be payable.
        </p>
      </div>
      <svg
        class="ml-auto lg:mr-0 md:mr-0 mr-5"
        width="119"
        height="26"
        viewBox="0 0 119 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M113 26H6C2.686 26 0 23.314 0 20V6C0 2.686 2.686 0 6 0H113C116.314 0 119 2.686 119 6V20C119 23.314 116.314 26 113 26ZM11.128 8.892H8.571V16.133H9.918V13.533H11.128C12.602 13.533 13.654 12.586 13.654 11.218C13.654 9.85 12.602 8.892 11.128 8.892ZM17.043 10.745C15.454 10.745 14.328 11.881 14.328 13.502C14.328 15.112 15.454 16.259 17.043 16.259C18.632 16.259 19.748 15.112 19.748 13.502C19.748 11.881 18.632 10.745 17.043 10.745ZM26.936 10.871L25.873 14.449L24.81 10.871H23.59L22.527 14.449L21.464 10.871H20.117L21.927 16.133H23.137L24.2 12.555L25.274 16.133H26.484L28.283 10.871H26.936ZM31.252 10.745C29.747 10.745 28.653 11.871 28.653 13.46C28.653 15.101 29.768 16.259 31.357 16.259C31.946 16.259 32.546 16.122 33.146 15.849V14.722C32.599 15.038 32.062 15.217 31.578 15.217C30.694 15.217 30.063 14.67 29.978 13.87H33.546C33.567 13.691 33.567 13.523 33.567 13.375C33.567 11.829 32.63 10.745 31.252 10.745ZM37.724 10.797C37.577 10.755 37.43 10.745 37.282 10.745C36.83 10.745 36.367 10.976 35.988 11.397V10.871H34.641V16.133H35.988V12.618C36.335 12.176 36.809 11.934 37.251 11.934C37.409 11.934 37.577 11.955 37.724 11.997V10.797ZM40.808 10.745C39.303 10.745 38.209 11.871 38.209 13.46C38.209 15.101 39.324 16.259 40.913 16.259C41.503 16.259 42.103 16.122 42.702 15.849V14.722C42.155 15.038 41.619 15.217 41.134 15.217C40.251 15.217 39.619 14.67 39.535 13.87H43.102C43.123 13.691 43.123 13.523 43.123 13.375C43.123 11.829 42.187 10.745 40.808 10.745ZM48.912 8.566H47.554V11.229C47.144 10.913 46.681 10.745 46.218 10.745C44.818 10.745 43.84 11.881 43.84 13.502C43.84 15.122 44.818 16.259 46.218 16.259C46.681 16.259 47.144 16.091 47.554 15.764V16.133H48.912V8.566ZM55.69 10.745C55.238 10.745 54.774 10.913 54.354 11.229V8.566H53.007V16.133H54.354V15.764C54.774 16.091 55.238 16.259 55.69 16.259C57.1 16.259 58.068 15.122 58.068 13.502C58.068 11.881 57.1 10.745 55.69 10.745ZM62.31 10.871L61.037 14.323L59.774 10.871H58.395L60.405 15.943L59.395 18.437H60.7L63.689 10.871H62.31ZM73.109 10.288C73.972 10.288 75.069 10.552 75.933 11.019V8.344C74.992 7.969 74.052 7.825 73.111 7.825C70.808 7.825 69.273 9.028 69.273 11.038C69.273 14.181 73.589 13.671 73.589 15.026C73.589 15.551 73.133 15.721 72.5 15.721C71.559 15.721 70.345 15.332 69.392 14.814V17.525C70.448 17.979 71.518 18.169 72.497 18.169C74.858 18.169 76.485 17.003 76.485 14.959C76.485 11.573 72.144 12.181 72.144 10.903C72.144 10.46 72.514 10.288 73.109 10.288ZM82.18 8.014H80.024L80.022 5.548L77.25 6.138L77.237 15.247C77.237 16.928 78.502 18.169 80.187 18.169C81.115 18.169 81.801 18.001 82.179 17.793V15.482C81.816 15.627 80.024 16.148 80.024 14.475V10.435H82.18V8.014ZM88.275 8.015C87.897 7.879 86.57 7.631 85.905 8.853L85.727 8.014H83.272V17.966H86.11V11.219C86.781 10.338 87.914 10.508 88.275 10.625V8.015ZM91.999 4.23L89.149 4.836V7.149L91.999 6.543V4.23ZM91.999 8.014H89.149V17.966H91.999V8.014ZM98.125 7.825C97.012 7.825 96.293 8.349 95.901 8.715L95.753 8.014H93.253L93.254 21.268L96.093 20.664L96.099 17.451C96.507 17.75 97.114 18.169 98.108 18.169C100.139 18.169 101.997 16.535 101.997 12.927C101.997 9.621 100.119 7.825 98.125 7.825ZM107.049 7.825C104.348 7.825 102.704 10.121 102.704 13.013C102.704 16.437 104.642 18.169 107.408 18.169C108.765 18.169 109.784 17.861 110.555 17.433V15.146C109.781 15.536 108.893 15.774 107.766 15.774C106.659 15.774 105.684 15.382 105.557 14.051H111.116C111.129 13.898 111.154 13.303 111.154 13.028C111.154 10.12 109.746 7.825 107.049 7.825ZM107.031 10.14C107.728 10.14 108.468 10.677 108.468 11.955H105.532C105.532 10.676 106.321 10.14 107.031 10.14ZM97.446 15.661C96.78 15.661 96.383 15.421 96.107 15.122L96.09 10.903C96.386 10.578 96.795 10.34 97.446 10.34C98.485 10.34 99.2 11.504 99.2 12.989C99.2 14.518 98.496 15.661 97.446 15.661ZM55.406 15.101C55.038 15.101 54.669 14.943 54.354 14.628V12.376C54.669 12.06 55.038 11.902 55.406 11.902C56.164 11.902 56.69 12.555 56.69 13.502C56.69 14.449 56.164 15.101 55.406 15.101ZM46.513 15.101C45.744 15.101 45.218 14.449 45.218 13.502C45.218 12.555 45.744 11.902 46.513 11.902C46.881 11.902 47.249 12.06 47.554 12.376V14.628C47.249 14.943 46.881 15.101 46.513 15.101ZM40.756 11.786C41.355 11.786 41.787 12.281 41.829 12.997H39.535C39.598 12.271 40.103 11.786 40.756 11.786ZM31.199 11.786C31.799 11.786 32.231 12.281 32.273 12.997H29.978C30.042 12.271 30.547 11.786 31.199 11.786ZM17.043 15.133C16.254 15.133 15.707 14.47 15.707 13.502C15.707 12.534 16.254 11.871 17.043 11.871C17.822 11.871 18.369 12.534 18.369 13.502C18.369 14.47 17.822 15.133 17.043 15.133ZM10.939 12.439H9.918V9.987H10.939C11.718 9.987 12.265 10.482 12.265 11.218C12.265 11.944 11.718 12.439 10.939 12.439Z"
          fill="#32364E"
        />
      </svg>
    </div>
  </div>
</template>

<script>
import { DateTime } from "luxon";
const services = [
  {
    name: "Our Legal Free",
    description: "",
    amount: "£920",
  },
  {
    name: "Stamp Duty Land Tax Fee",
    description: "",
    amount: "£185",
  },
  {
    name: "Stamp Duty",
    description: "",
    amount: "£3800",
  },
  {
    name: "Land Registry Fee",
    description: "",
    amount: "£218",
  },
  {
    name: "Land Registry Searches",
    description: "",
    amount: "£10",
  },
  {
    name: "Search Packs",
    description: "",
    amount: "£538",
  },
  {
    name: "VAT",
    description: "",
    amount: "£192",
  },
  {
    name: "TOTAL",
    description: "",
    amount: "£5568.00",
  },
];
import { loadStripe } from "@stripe/stripe-js";
import { createTemporaryCase } from "../../../services/case";
import { createPayment } from "../../../services/payment";
import { onMounted, computed } from "vue";
import { useStore } from "vuex";
import vuexStore from "../../../store";

export default {
  beforeRouteEnter(to, from, next) {
    const state = vuexStore.state.cases;
    const {
      purchase_case,
      sell_case,
      property,
      personal: { first_name },
    } = state;
    let isValid = true;
    if (property === "both") {
      if (!purchase_case.amount || !sell_case.amount) {
        isValid = false;
      }
    } else if (
      property === "sale" ? !sell_case.amount : !purchase_case.amount
    ) {
      isValid = false;
    }
    if (!isValid || !property || !first_name) {
      next({ name: 3 });
    } else {
      next();
    }
  },
  setup() {
    const store = useStore();
    let stripe = null;
    onMounted(async () => {
      stripe = await loadStripe(process.env.VUE_APP_STRIPE_PK);
    });

    const formatCurrency = (amount) => {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "GBP",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(amount / 100);
    };

    const redirectToCheckout = async () => {
      const { sell_case, purchase_case, personal, property } =
        store.state.cases;
      const sell = { ...sell_case };
      const purchase = { ...purchase_case };

      try {
        const {
          data: { id: session_id, payment_intent },
        } = await createPayment(property);

        let cases = [];

        switch (property) {
          case "both":
            sell.payment_intent = payment_intent;
            sell.message = personal.message;

            purchase.payment_intent = payment_intent;
            purchase.message = personal.message;

            cases = [sell, purchase];
            break;
          case "sale":
            sell.payment_intent = payment_intent;
            sell.message = personal.message;
            cases = [sell];
            break;
          case "purchase":
            purchase.payment_intent = payment_intent;
            purchase.message = personal.message;
            cases = [purchase];
            break;
          default:
            break;
        }

        if (cases.length === 0) return;

        await createTemporaryCase({
          user_info: {
            first_name: personal.first_name,
            last_name: personal.last_name,
            phone: personal.phone_number,
            email_address: personal.email,
            address: {
              street_address: personal.street_address,
              postcode: personal.postcode,
              city: personal.city,
              country: personal.country,
            },
          },
          case_info: cases,
        });

        stripe.redirectToCheckout({ sessionId: session_id });
      } catch (e) {
        console.log(e);
      }
    };

    return {
      cases: computed(() => store.state.cases),
      formatCurrency,
      services,
      DateTime,
      redirectToCheckout,
    };
  },
};
</script>

<style></style>
